import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { InfoFormControl } from './info-form-control';

@Component({
  standalone: false,
  selector: 'app-info-form-control',
  templateUrl: './info-form-control.component.html',
  styleUrls: ['./info-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InfoFormControlComponent),
      multi: true
    }
  ]
})
export class InfoFormControlComponent
  extends AbstractFormControlComponent<InfoFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  get isMultiline(): boolean {
    return this.control.isMultiline;
  }

  get rowsCount(): number {
    return this.control.rowsCount || 1;
  }

  get valueLength(): number {
    if (!this.control.value) {
      return 0;
    }

    const value = this.control.value as string;
    return value.length;
  }

  get maxLength(): number {
    return this.control.maxLength;
  }

  getCaretPos(oField: any) {
    if (oField.selectionStart || oField.selectionStart === '0') {
      this.control.caretPos = oField.selectionStart;
    }
  }
}
